import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import Show from '@/newcar/ui/molecule/Show';
import * as style from './index.module.styl';

interface BaseRadioGroupProps
  extends StandardProps {
  /**
   * @ignore
   */
  children?: React.ReactNode;

  /**
   * @default ''
   */
  label?: string;

  /**
   * @default ''
   */
  adornmentStart?: string;

  /**
   * @default ''
   */
  adornmentStartClass?: string;

  /**
   * @default ''
   */
  gridClass?: string;

  /**
   * @default ''
   */
  errorMessage?: string;

  /**
   * @default true
   */
  visible?: boolean;
}

export declare type RadioGroupProps = BaseRadioGroupProps;

/**
 * ラジオボタンのラッパーコンポーネント
 *
 * @export
 * @param {RadioGroupProps} props
 * @return {*}  {JSX.Element}
 */
export default function RadioGroup(props: RadioGroupProps): JSX.Element {
  const {
    children,
    label = '',
    className = '',
    adornmentStart = '',
    adornmentStartClass = '',
    gridClass = '',
    errorMessage = '',
  } = props;
  return (
    <div className={className}>
      <div className="is-margin-bottom-3">
        <Show when={label !== ''}>
          <p>
            {label}
          </p>
        </Show>
        <Show when={adornmentStartClass !== ''}>
          <p className={adornmentStartClass}>
            {adornmentStart}
          </p>
        </Show>
      </div>
      <div
        className={`is-relative ${gridClass}`}
        style={style}
      >
        <div
          className={`columns is-mobile is-multiline ${style.radioGap}`}
          aria-invalid={errorMessage !== ''}
        >
          {children}
        </div>
      </div>
      <div className={`is-padding-top-1 ${style.error}`}>
        <Show when={errorMessage !== ''}>
          <p className="is-padding-top-5 has-text-weight-bold is-size-6 has-text-danger">
            {errorMessage}
          </p>
        </Show>
      </div>
    </div>
  );
}
